import { gql } from '@apollo/client'

export const FAVORITES_QUERY = gql`
{
	currentUserFavouriteContent {
		entityLabel
		entityBundle
		... on NodePlaylist {
            uuid
            entityChanged
            entityId
            isLikedByCurrentUser
            fieldPlaylistImportedFromSap
            fieldPlaylistDescription
            title
        }
		... on NodeResource {
			uuid
			entityChanged
			entityId
			entityLabel
			entityType
			fieldResourceDescription
			isLikedByCurrentUser
			fieldResourceImportedFromSap
			fieldResourceFromDate
			fieldResourceReleaseDate
			fieldResourceOfflinePeriod {
                targetId
            }  
			fieldResourceFilesByFormat {
				entity {
					... on Media {
						uuid
					    entityChanged
						entityLabel
						entityType
						entityBundle
						entityId
					}
					... on MediaMediaFile {
						fieldMediaFileLanguage {
							value
						}
						fieldMediaFile {
							entity {
								... on File {
								    uuid
									entityChanged
									url
									filesize
									filemime
									filename
								}
							}
						}
					}
					... on MediaSapFile {
					    uuid
						entityChanged
						entityId
						fieldSapFromDate
						fieldSapReleaseDate
						fieldSapFileFileSize
						fieldSapFileFileName
						fieldSapFileDocumentVersion
						fieldSapFileMime
						fieldSapFileLanguage {
							value
						}
						fieldSapFileFileExtension {
							entity {
								... on TaxonomyTermFileExtension {
									fieldFileExtensionValue
								}
							}
						}
					}
					... on MediaMasterControl {
             uuid
             entityChanged
             entityId
             fieldMasterControlId
             fieldMasterControlCategory
             fieldMasterControlDescription
             fieldMasterControlTitle
             fieldMasterControlRevision
             fieldMasterControlMime
             fieldMasterControlSize
             fieldMasterControlExtension {
              entity {
                ... on TaxonomyTermFileExtension {
                  fieldFileExtensionValue
                }
              }
             }
          }
          ... on MediaMasterControlAttachment {
             uuid
             entityChanged
             entityId
             fieldMcAttachmentId
             fieldMcAttachmentName
             fieldMcAttachmentDescription
             fieldMcAttachmentMime
             fieldMcAttachmentSize
             fieldMcAttachmentExtension {
              entity {
                ... on TaxonomyTermFileExtension {
                  fieldFileExtensionValue
                }
              }
             }
          }
          ... on MediaBokeccVideo {
              fieldBokeccIframe
          }
				}
			}
		}
	}
}
`;